<div
    class="flex flex-col flex-auto items-center sm:justify-center min-w-0 sm:p-8 md:py-16 md:px-16"
>
    <div class="flex w-full h-full rounded-2xl shadow-2xl overflow-hidden">
        <div
            class="flex flex-col justify-stretch h-full w-full p-12 overflow-hidden dark:border-r"
        >
            <div class="flex flex-row justify-stretch w-full items-center">
                <!-- Avatar and name -->
                <div class="flex flex-auto items-center min-w-0">
                    <div
                        class="flex items-center justify-center w-16 h-16 rounded-full overflow-hidden bg-[#FE4F30] text-black text-center text-3xl"
                    >
                        {{ selectedTenant!.businessName!.charAt(0) }}
                    </div>
                    <div class="flex flex-col min-w-0 ml-4 text-black">
                        <div
                            class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate"
                        >
                            {{ selectedTenant!.businessName }}
                            {{
                                companyStore.selectedCompany()
                                    ? ', ' +
                                      companyStore.selectedCompany()!.code
                                    : ''
                            }}</div
                        >
                        <div class="flex items-center">
                            <div class="leading-6 truncate"
                                >Select branch to continue</div
                            >
                        </div>
                    </div>
                </div>
                <!-- Actions -->
                <div class="flex items-center">
                    <button
                        mat-stroked-button
                        [color]="'secondary'"
                        (click)="onChangeTenant()"
                    >
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_outline:building-office'"
                        ></mat-icon>
                        <span class="ml-2">Switch Organization</span>
                    </button>
                </div>
            </div>

            <div
                *ngIf="!companyStore.isLoading()"
                class="flex flex-col w-full h-full items-center justify-center p-6"
            >
                <div
                    *ngIf="
                        companyStore.selectedCompany()?.branches?.length ??
                            0 > 0;
                        else noBranch
                    "
                    class="flex flex-row gap-4 flex-wrap m-8 items-center justify-center"
                >
                    <ng-container
                        *ngFor="
                            let branch of companyStore.selectedCompany()
                                ?.branches
                        "
                    >
                        <a
                            class="flex flex-col items-center justify-around w-56 h-56 p-6 bg-card rounded-lg cursor-pointer transition-shadow duration-150 ease-in-out hover:shadow-xl"
                            (click)="selectBranch(branch)"
                        >
                            <div
                                class="flex items-center justify-center p-4 h-20 w-20 rounded-full bg-gradient-to-b from-[#FE4F30] from-10% to-[#E12A6D] to-70% text-white font-medium text-4xl"
                            >
                                {{ branch.name?.charAt(0) }}
                            </div>
                            <!-- Title -->
                            <div
                                class="mt-4 text-lg font-medium leading-5 line-clamp-2 text-gray-800 text-center"
                                >{{ branch.name }}</div
                            >
                        </a>
                    </ng-container>
                </div>

                <ng-template #noBranch>
                    <div
                        (click)="selectBranch(null)"
                        class="flex flex-col items-center justify-center w-56 h-56 rounded-lg cursor-pointer border-2 border-gray-300 border-dashed hover:bg-hover transition-colors duration-150 ease-in-out"
                    >
                        <mat-icon
                            class="icon-size-12 text-hint"
                            [svgIcon]="'heroicons_outline:building-office-2'"
                        ></mat-icon>
                        <span class="mt-4 font-medium text-secondary text-md"
                            >No Branch Found</span
                        >

                        <!-- (click)="createTenant()"
                       [disabled]="disableCreateButton" -->
                    </div>
                </ng-template>
            </div>

            <div
                *ngIf="companyStore.isLoading()"
                class="flex flex-col w-full h-full items-center justify-center p-6"
            >
                Loading..
            </div>

            <!-- Footer -->
            <div class="flex flex-col items-center justify-center w-full mt-8">
                <div class="flex items-center justify-center h-20">
                    <img
                        class="w-64"
                        [src]="branding.currentFullLogoUrl()"
                        [alt]="branding.logoAlt"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
